<template>
  <div class="address-form-toggle">
    <div class="address-form-toggle__toggle">
      <label>
        <input type="hidden" :name="name" value="0" />
        <input
          v-model="value"
          class="base-checkbox"
          type="checkbox"
          :name="name"
          value="1"
        />
        <span class="address-form-toggle__label">{{ label }}</span>
      </label>

      <div
        v-show="address && address.name && address.address"
        class="address-form-toggle__address"
      >
        <div class="address-form-toggle__summary-name">
          {{ address.name }}
        </div>
        <div class="address-form-toggle__summary-address">
          {{ address.address }}
        </div>
      </div>
    </div>

    <div v-if="!value" class="address-form-toggle__fields">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressFormToggle',
  props: {
    label: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    checked: Boolean,
    address: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      value: this.checked,
    };
  },
  mounted() {
    const labelInputWithErrors = document.querySelector(
      '.label-input--with-errors'
    );

    if (null !== labelInputWithErrors) {
      document.body.scrollTo(
        0,
        labelInputWithErrors.getBoundingClientRect().top
      );
    }
  },
};
</script>
